module.exports = __webpack_public_path__ + "static/media/Player_Hit_2.970e6f55.wav";